import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=b4e723b8"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QImg,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QImg,QItemLabel,QItem,QItemSection,QAvatar,QExpansionItem,QIcon})
